module.exports = __webpack_public_path__ + "img/Sound2.352013bb.png";